import {Controller} from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo"

import Debug from 'debug';
import {subscribe} from "@root/server/client/esweb/src/lib/ws.ts";

export const name = 'lib--channel';
const debug = Debug(name);


export default class extends Controller {
    static values = {
        sigChannel: String,
    }

    declare sigChannelValue: string;

    unsubscribe: (() => void) | null = null;

    connect() {
        debug('sigChannelValue', this.sigChannelValue)

        this.unsubscribe = subscribe(this.sigChannelValue, (event) => {
            Turbo.renderStreamMessage(event.detail.data);
        })
    }

    disconnect() {
        debug('disconnect')
        if(this.unsubscribe) {
            this.unsubscribe();
        }
    }

}